// Global Instructions Rule Applied! - Jul 28, 2026
import React from 'react'
import { Dropdown } from 'antd'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { useQuickAdd, type QuickAddEntity } from '../../contexts/QuickAddContext.jsx'

// Form entities open ALONE in the global quick-add overlay (owner
// 2026-08-17) — no module grid mounts. Routes remain the fallback when no
// QuickAddProvider is mounted, and for full-page items (bulk-prospects).
const ADD_MENU_ROUTES: Record<string, string> = {
  company: '/companies/forms/drawer/new',
  contact: '/contacts/forms/drawer/new',
  deal: '/deals/forms/drawer/new',
  prospect: '/fundraising/forms/drawer/new',
  'bulk-prospects': '/bulk-add-prospects'
}

const QUICK_ADD_ENTITIES: readonly QuickAddEntity[] = ['company', 'contact', 'deal', 'prospect']
const isQuickAddEntity = (key: string): key is QuickAddEntity => QUICK_ADD_ENTITIES.some((e) => e === key)

const addMenuItems = [
  { key: 'company', label: 'New Company' },
  { key: 'contact', label: 'New Contact' },
  { key: 'deal', label: 'New Deal' },
  { key: 'prospect', label: 'New Prospect' },
  { key: 'bulk-prospects', label: 'Bulk Prospects' }
]

export function NavbarAddButton() {
  const navigate = useNavigate()
  const quickAdd = useQuickAdd()

  const handleMenuClick = ({ key }: { key: string }) => {
    if (quickAdd && isQuickAddEntity(key)) {
      quickAdd.openQuickAdd(key)
      return
    }
    const route = ADD_MENU_ROUTES[key]
    if (route) {
      navigate(route)
    }
  }

  return (
    <Dropdown menu={{ items: addMenuItems, onClick: handleMenuClick }} trigger={['click']} placement='bottomRight'>
      <button
        className='p-1.5 rounded-lg transition-colors hover:bg-white hover:bg-opacity-10 cursor-pointer'
        aria-label='Add record'
      >
        <FontAwesomeIcon icon={faPlus} className='text-white text-base' />
      </button>
    </Dropdown>
  )
}
